import React from 'react';
import { TbChecklist, TbHome, TbHomeFilled, TbMapPin, TbMapPinFilled, TbUser, TbUserSquareRounded } from "react-icons/tb";
import { useLoginContext } from '../../Contexts/LoginContext';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useStoreHook } from '../../Hooks/StoreHook';
import { useStoreContext } from '../../Contexts/StoreContext';

const MenuMobile = () => {

  const { token, setShowLoginBasic } = useLoginContext();
  const location = useLocation();
  const { getLinkToHome } = useStoreHook();
  const { currentStore } = useStoreContext();
  const navigate = useNavigate();

  // const headerMenu = [
  //   { name: 'Home', href: `/${orderTypeAsSlug(orderType)}/${slug ?? ''}`, icon: <TbHome /> },
  //   { name: 'Lojas', href: '/lojas', icon: <TbBuildingSkyscraper /> },
  //   { name: 'Fidelidade', href: '/', icon: <HiMiniUserGroup /> },
  //   //{ name: 'Pagamento', href: '/', icon: <TbCreditCard /> },
  // ]

  const isHome = location.pathname === getLinkToHome();

  const defaultClassName = `
      flex flex-col gap-0.5 items-center justify-center
      w-full h-full
      z-30
      hover:bg-gray-100
      transition ease-in-out duration-400
      disabled:pointer-events-none
      disabled:text-gray-300
      `;
  const linkActived = 'pointer-events-none text-custom-primary'
  const linkDisabled = 'pointer-events-none opacity-50'

  return (
    <div className='flex justify-between w-full h-full text-xs font-semibold bg-white rounded-t-xl shadow-reverse-md'>

      <Link to={getLinkToHome()} className={`
        ${defaultClassName}
        ${isHome && linkActived}
        ${!currentStore && linkDisabled}
        `}>
        {isHome ? <TbHomeFilled size={23} className='zoomInIconNoDelay' /> : <TbHome size={23} /> }
        Home
      </Link>

      <Link to='/lojas' className={`${defaultClassName} ${location.pathname === '/lojas' && linkActived}`}>
        {location.pathname === '/lojas' ? <TbMapPinFilled size={23} className='zoomInIconNoDelay' /> : <TbMapPin size={23} /> }
        Lojas
      </Link>

      {/* {order &&
        <div className='relative'>
          <Link to={urlToOrderPlaced} className={`
            ${defaultClassName}
            relative
            shadow-2xl
            rounded-full
            bg-custom-primary hover:bg-custom-primary text-white hover:text-white
            absolute
            -top-1
            min-w-20 max-w-20
            min-h-20 max-h-20
            leading-none
          `}>
            <div className="flex flex-col items-center justify-center leading-none">
              <span className='opacity-70 leading-none'>Pedido</span>
              <span className='font-black text-lg leading-none'>{ Number(formatCartId(order.id)) }</span>
            </div>
          </Link>
        </div>
      } */}

      <Link to={'/perfil/meus-pedidos'} className={`
        ${defaultClassName}
        ${location.pathname === '/perfil/meus-pedidos' && linkActived}
        ${!token && linkDisabled}
      `}>
        {location.pathname === '/perfil/meus-pedidos' ? <TbChecklist size={23} className='zoomInIconNoDelay' /> : <TbChecklist size={23} /> }
        Pedidos
      </Link>

      <button
        onClick={() => !token ? setShowLoginBasic(true) : navigate('/perfil/meus-pedidos')} className={`
          ${defaultClassName}
          ${location.pathname === '/perfil' && linkActived}
          ${!currentStore && linkDisabled}
        `}>
        <div>
          { !token
            ? <TbUser size={23} />
            : location.pathname === '/perfil'
              ? <TbUserSquareRounded size={23} className='zoomInIconNoDelay' />
              : <TbUserSquareRounded size={23} />
          }
        </div>
        <div>{token ? 'Perfil' : 'Entrar'}</div>
      </button>

      {/* MENU POPOVER MOBILE */}
      {/* <Popover className="relative flex w-full justify-center hover:bg-gray-50">
          <PopoverButton className="inline-flex items-center justify-center w-full focus:outline-none focus:ring-0">
              <HiBars3 size={27} />
          </PopoverButton>

          <PopoverPanel
              transition
              className="absolute bottom-14 z-10 flex w-auto right-0 -translate-x-0 px-4 transition data-[closed]:translate-y-1 data-[closed]:opacity-0 data-[enter]:duration-200 data-[leave]:duration-150 data-[enter]:ease-out data-[leave]:ease-in"
          >
              <div className="max-w-auto flex-auto divide-red-500 overflow-hidden rounded-lg bg-white shadow-lg ring-1 ring-gray-900/5">
                  <div className="overflow-hidden divide-y divide-gray-100">
                      {headerMenu.map((item) => (
                          <div key={item.name} className="group relative flex hover:bg-gray-50">
                              <Link to={item.href} className="flex items-center gap-1 w-full text-nowrap font-semibold text-sm p-3 leading-5">
                                  {item.icon}
                                  <span>{item.name}</span>
                              </Link>
                          </div>
                      ))}
                  </div>
              </div>
          </PopoverPanel>
      </Popover> */}
    </div>
  )
}

export default MenuMobile;